// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgX12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.766 2.234a.799.799 0 0 0-1.13 0L6.005 4.865 3.374 2.234a.799.799 0 0 0-1.13 1.13l2.631 2.631-2.631 2.631a.8.8 0 1 0 1.13 1.13l2.631-2.631 2.631 2.631a.799.799 0 0 0 1.13-1.13L7.135 5.995l2.631-2.631a.799.799 0 0 0 0-1.13Z"
		/>
	</svg>
);
export default SvgX12;
